<template>
  <div class="container white pa-0">
    <!-- modal informação -->
    <ModalInformationsWallet
      :show="showWalletInformations"
      @close="
        showWalletInformations = false;
        addMoney = true;
      "
    ></ModalInformationsWallet>

    <!-- Modal Loading -->
    <v-dialog persistent max-width="300" v-model="blockScreen">
      <v-card class="px-3 py-5 text-center">
        <div class="text-center pb-5">
          <span class="title font-weight-bold"
            >Aguarde, estamos processando os dados...</span
          >
        </div>
        <v-progress-circular
          :size="70"
          :width="7"
          class="checkin-text"
          indeterminate
        ></v-progress-circular>
      </v-card>
    </v-dialog>

    <!-- menu superior -->
    <v-layout column class="menu w-100 white">
      <v-card elevation="2" tile>
        <v-layout
          align-center
          justify-space-around
          class="py-2 px-3 colorSelectedBack sizeTop"
        >
          <img
            :src="require(`@/assets/logos/uc_carsharing_branco.png`)"
            alt="pickndrive"
            style="width: auto; height:39px;"
          />
        </v-layout>
      </v-card>
    </v-layout>

    <!-- alertas -->
    <v-snackbar top v-model="snackbar" :color="snackbarColor" multi-line>
      {{ snackbarText }}
      <v-btn dark icon text @click="snackbar = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>

    <!-- excluir cartao -->
    <modal
      :showModal="deleteCard"
      :ifTitle="true"
      :Title="'Tem certeza que quer excluir o cartão?'"
      :ifIcon="true"
      :Icon="'credit_card'"
      :ifTwoBtn="true"
      :TextFirstBtn="'Não'"
      :TextSecondBtn="'Sim'"
      @btnUm="deleteCard = !deleteCard"
      @btnDois="DeleteCard()"
    ></modal>

    <div style="height:48px"></div>

    <v-card text v-if="ifCard" class="px-2 py-4">
      <v-layout column>
        <v-layout align-center pa-2 pt-4>
          <v-icon medium class="total">account_balance_wallet</v-icon>
          <span class="pl-2 py-2 subheading font-weight-medium total"
            >Saldo em carteira: R$ {{ saldo | formatPrice }}</span
          >
        </v-layout>
        <v-btn large class="btnColor px-0" @click="mostrarInformacoesWallet">
          <span class="white--text font-weight-bold">Adicionar saldo</span>
        </v-btn>
        <v-divider></v-divider>
        <v-btn large class="btnColor px-0" @click="newCard = !newCard">
          <span class="white--text font-weight-bold">Cadastrar Cartão</span>
        </v-btn>
        <v-layout align-center pa-2 pt-4>
          <v-icon medium class="total">credit_card</v-icon>
          <span class="pl-2 subheading font-weight-medium total"
            >Cartão de crédito:</span
          >
        </v-layout>
        <!-- Para cada cartão -->
        <v-card
          v-for="(card, index) in cards"
          :key="index"
          class="mx-2 my-2 pl-2 "
        >
          <v-layout align-center>
            <span class="subheading pl-2 font-weight-regular total">{{
              card.nickname
            }}</span>
            <v-spacer></v-spacer>
            <v-btn
              icon
              class="colorSelected"
              @click="card_id = card.id; card_nickname = card.nickname; dialogEditCvv = true;"
            >
              <v-icon>edit</v-icon>
            </v-btn>
            <v-btn
              icon
              class="colorSelected"
              @click="(card_id = card.id), (deleteCard = !deleteCard)"
            >
              <v-icon>delete_outline</v-icon>
            </v-btn>
          </v-layout>
        </v-card>
        <v-divider></v-divider>
        <v-layout align-center pa-2 pt-4>
          <v-icon medium class="outlined">confirmation_number</v-icon>
          <span class="pl-2 subheading font-weight-medium total"
            >Meus cupons:</span
          >
        </v-layout>
        <v-card
          v-for="(rescue, index) in rescues"
          :key="index"
          class="mx-2 my-2 pl-2 "
        >
          <v-layout align-center>
            <v-container style="height: auto">
              <v-row>
                <input type="hidden" :id="rescue.coupon.name" :value="rescue.coupon.name">
                <span class="subheading pl-2 font-weight-regular total">{{
                  rescue.coupon.name
                }}</span>
                <v-spacer></v-spacer>
                <v-btn
                  icon
                  class="colorSelected"
                  @click="copyCupon(rescue.coupon.name)"
                >
                  <v-icon>content_copy</v-icon>
                </v-btn>
              </v-row>
              <v-row>
                <span class="subheading pl-2 font-weight-regular total">Data de expiração: </span>

                <span class="subheading grey--text text--darken-2 pl-2">{{
                  formatDate(rescue.coupon.expiration_date)
                }}</span>
              </v-row>
            </v-container>
          </v-layout>
        </v-card>
      </v-layout>
    </v-card>

    <v-card class="px-2 py-4" v-if="!ifCard">
      <v-layout column class="text-center">
        <v-layout align-center pa-2 pt-4>
          <v-icon medium class="total">account_balance_wallet</v-icon>
          <span class="pl-2 subheading font-weight-medium total"
            >Saldo em carteira: R$ {{ saldo | formatPrice }}</span
          >
        </v-layout>
        <v-btn large class="btnColor px-0" @click="mostrarInformacoesWallet">
          <span class="white--text font-weight-bold">Adicionar saldo</span>
        </v-btn>
        <v-divider></v-divider>
        <span class="title grey--text text--darken-1 px-4"
          >Nenhum cartão cadastrado</span
        >
        <v-icon class="icon-size py-4">credit_card</v-icon>
        <v-btn large class="btnColor mx-5 px-0" @click="newCard = !newCard">
          <span class="white--text font-weight-medium">Cadastrar Cartão</span>
        </v-btn>
      </v-layout>
    </v-card>

    <div class="btn-invite">
      <a @click="$router.push('/user/convidar')">
        Indique um amigo e ganhe prêmios
        <v-icon> mdi-chevron-right </v-icon>
      </a>
    </div>

    <v-card class="bottom mb-5 px-2 py-4">
      <v-layout column class="text-center">
        <a target="_blank" href="https://bs2.app/360-TECHFLEET">
          <v-img
            class="px-3 py-2 align-end"
            max-height="100px"
            src="https://pickndrive.s3-sa-east-1.amazonaws.com/logos/pessoaFisicaBs2.jpeg"
          >
          </v-img>
        </a>
        <v-divider></v-divider>
        <a
          target="_blank"
          href="https://cadastro.empresas.bs2.com/bs2/?origemId=777CE507-040C-4847-8E5B-3C81653A5FDB"
        >
          <v-img
            class="px-3 py-2 align-end"
            max-height="100px"
            src="https://pickndrive.s3-sa-east-1.amazonaws.com/logos/pessoaJuridicaBs2.jpeg"
          >
          </v-img>
        </a>
      </v-layout>
    </v-card>

    <payment :showModal="newCard" @close="close()" @alert="alert($event)">
    </payment>
    <AddMoney
      :showModal="addMoney"
      @close="addMoney = false"
      @updateWallet="getWallet()"
    >
    </AddMoney>

    <v-dialog
    v-model="dialogEditCvv"
    width="500"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="red lighten-2"
          dark
          v-bind="attrs"
          v-on="on"
        >
          Click Me
        </v-btn>
      </template>

      <v-card>
        <v-card-title class="headline">
          {{ card_nickname || '' }}
        </v-card-title>
        <v-card-text>
          <v-text-field
            color="grey darken-2"
            v-mask="'###'"
            label="CVV do Cartão"
            v-model="newCVV"
            required
          ></v-text-field>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="default"
            text
            @click="dialogEditCvv = false"
          > Cancelar </v-btn>
          <v-btn
            color="primary"
            text
            @click="updateCVV(); dialogEditCvv = false"
          > Atualizar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import theming from "../../mixins/theming";
import UserController from "./../../controllers/UserController.js";
import User from "./../../models/User.js";
import CreditCardController from "./../../controllers/UserCreditCardController.js";
import ModalPadrao from "../shared/ModalPadrao.vue";
import payment from "./ModalPayment.vue";
import Deposit from "./Deposit.vue";
import ModalInformationsWallet from "./ModalInformationsWallet.vue";
import WalletController from "../../controllers/WalletController";
import NumberHelper from "./../../helpers/NumberHelper";
import RescuesController from "../../controllers/RescuesController";
import DateHelper from '../../helpers/DateHelper'

export default {
  mixins: [theming],

  components: {
    modal: ModalPadrao,
    payment,
    AddMoney: Deposit,
    ModalInformationsWallet
  },

  async created() {
    await this.getCards();
    await this.getWallet();
    await this.getCupons();
  },

  filters: {
    formatPrice(price) {
      if (price) return NumberHelper.formatPrice(price);
      else return 0.0;
    }
  },

  data() {
    return {
      showWalletInformations: false,
      ifCard: false,
      newCard: false,
      userController: new UserController(this.$resource),
      user: new User(),
      creditCardController: new CreditCardController(this.$resource),
      walletController: new WalletController(this.$resource),
      rescuesController: new RescuesController(this.$resource),
      cards: null,
      card_id: null,
      card_nickname: null,
      dialogEditCvv: false,
      deleteCard: false,
      snackbar: false,
      snackbarColor: "",
      snackbarText: "",
      modalComplete: null,
      blockScreen: false,
      addMoney: false,
      saldo: false,
      rescues: null,
      newCVV: null,
    };
  },

  methods: {
    async updateCVV() {
      try {
        await this.creditCardController.updateCVV(this.newCVV, this.card_id)
        this.$awn.success("CVV do cartão atualizado com sucesso");
      } catch (error) {
        this.$awn.alert("Erro ao atualizar o CVV do cartão");
      } finally {
        this.newCVV = null;
      }
    },

    formatDate(date) {
      return DateHelper.formatDate(date);
    },
    mostrarInformacoesWallet() {
      this.showWalletInformations = true;
    },

    async getCards() {
      this.blockScreen = true;
      await this.creditCardController
        .getByIdUser()
        .then(response => {
          this.cards = response;
          this.setCards();
        })
        .catch(error => {
          this.snackbarColor = "error";
          this.snackbarText = "Falha ao carregas cartões.";
          this.snackbar = true;
        });
      this.blockScreen = false;
    },

    async getCupons() {
      await this.rescuesController
        .getRescuesByUserId(localStorage.getItem("pickn_user"))
        .then(response => {
          this.rescues = response;
        })
        .catch(error => {
          this.snackbarColor = "error";
          this.snackbarText = "Falha ao carregas cupons.";
          this.snackbar = true;
        });
    },

    close() {
      this.newCard = !this.newCard;
      this.getCards();
    },

    setCards() {
      this.cards.length != 0 ? (this.ifCard = true) : (this.ifCard = false);
    },

    async DeleteCard() {
      try {
        await this.creditCardController.delete(this.card_id);

        this.deleteCard = !this.deleteCard;

        this.snackbarColor = "success";
        this.snackbarText = "Cartão excluído com sucesso!";
        this.snackbar = true;

        this.getCards();
        this.card_id = null;
      } catch (e) {
        this.deleteCard = !this.deleteCard;
        this.snackbarColor = "error";
        this.snackbarText = "Falha ao excluir cartão.";
        this.snackbar = true;
      }
    },
    alert(alert) {
      this.snackbarText = alert.text;
      this.snackbarColor = alert.color;
      this.snackbar = true;
    },

    getWallet() {
      this.walletController.get().then(result => {
        this.saldo = result.money;
      });
    },
    copyCupon (idSelector) {
      idSelector  = `#${idSelector}`
      let codeToCopy = document.querySelector(idSelector)
      codeToCopy.setAttribute('type', 'text')
      codeToCopy.select()

      try {
        var successful = document.execCommand('copy');
        this.copy = successful ? 'COPIADO': 'COPIAR';
      } catch (err) {
        console.log('Oops, unable to copy');
      }

      /* unselect the range */
      codeToCopy.setAttribute('type', 'hidden')
      window.getSelection().removeAllRanges()
    },
  }
};
</script>

<style scoped>
.btn-invite {
  padding: 16px 8px;
  display: flex;
  justify-content: center;
}

.btn-invite a {
  width: 100%;
  padding: 17px 8px 12px 15px;
  font-size: 14px;
  line-height: 20px;
  background: #99439a;
  color: #fff;
  border-radius: 8px;
  margin: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-decoration: none;
}

.btn-invite a i {
  color: #fff;
}

.container {
  position: relative;
  height: 100vh;
}

.sizeTop {
  height: 48px;
}

.menu {
  position: fixed;
  top: 0px;
  z-index: 1;
}

.bottom {
  margin-bottom: 60px;
}

.colorSelectedBack {
  background-color: var(--secondary-color);
}

.colorSelected {
  color: var(--secondary-color) !important;
}

.btnColor {
  background-color: var(--primary-color) !important;
}

.icon-size {
  font-size: 60px;
}

.total {
  color: #181f4d;
}

.float {
  position: absolute;
  color: var(--secondary-color);
  top: 0;
  right: 0;
}
</style>
